<ng-container
  *ngIf="{
    product: product$ | async,
  } as content"
>
  <div class="container-product-efficiency">
    @if (content.product?.efficiency?.length) {
      <table class="table-responsive table-md m-t-20">
        <thead>
          <tr>
            <th>{{ 'efficiency.country' | cxTranslate }}</th>
            <th>{{ 'efficiency.efficiency' | cxTranslate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let country of content.product?.efficiency">
            <td>
              <span class="responsive-title"> {{ 'efficiency.country' | cxTranslate }}: </span>

              {{ country.name }}
            </td>

            <td>
              <div class="status">
                <span class="responsive-title"> {{ 'efficiency.efficiency' | cxTranslate }}: </span>

                @if (country.hasEfficiency) {
                  <span class="d-flex icon text-success material-symbols-outlined"> check_circle </span>
                } @else {
                  <span class="d-flex icon text-danger material-symbols-outlined"> cancel </span>
                }
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    } @else {
      <p class="text-center m-0">{{ 'efficiency.noInformation' | cxTranslate }}</p>
    }
  </div>
</ng-container>